import React, { FC } from 'react'
import { Image } from 'antd-mobile'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Pagination } from 'swiper/modules'
import { jumpToUrl } from '@/utils'
import css from './index.module.less'
import { useNavigate } from 'react-router-dom'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'

interface BannerItem {
  bannerUrl?: string;
  jumpUrl?: string;
  state?: number;
}

interface BannerSwiperProps {
  fallbackImage?: string; // 兜底图片
  list?: BannerItem[];
  className?: string;
}

const BannerSwiper: FC<BannerSwiperProps> = ({ 
  className = '',
  fallbackImage,
  list
}) => {
  const navigate = useNavigate()
  // 点击轮播图处理
  const handleBannerClick = (banner: BannerItem) => {
    (window as any)?._hmt?.push(['_trackEvent', 'banner', 'click', banner?.jumpUrl]);
    if (banner.jumpUrl) {
      // jumpToUrl(banner.jumpUrl)
      navigate(`/image-show?image=${banner.jumpUrl}`)

    }
  };

  return (
    <div className={`${css.bannerContainer} ${className}`}>
      {list?.length > 0 ? (
        <Swiper
          modules={[Autoplay, Pagination]}
          spaceBetween={0}
          slidesPerView={1}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
            bulletClass: css.swiperBullet,
            bulletActiveClass: css.swiperBulletActive,
          }}
          loop={list.length > 1}
          className={css.bannerSwiper}
        >
          {list.map((banner, index) => (
            <SwiperSlide key={index}>
              {/* 移动端：简单展示（原始样式） */}
              <div 
                className={css.bannerSlideMobile}
                onClick={() => handleBannerClick(banner)}
              >
                <Image 
                  src={banner.bannerUrl} 
                  alt={`${index + 1}`}
                  className={css.bannerImageMobile}
                />
              </div>

              {/* PC端：带背景蒙版 */}
              <div 
                className={css.bannerSlidePC}
                onClick={() => handleBannerClick(banner)}
              >
                {/* 背景蒙版层 */}
                <div 
                  className={css.bannerBackgroundMask} 
                  style={{ backgroundImage: `url(${banner.bannerUrl})` }}
                />
                {/* 居中显示的图片 */}
                <Image 
                  src={banner.bannerUrl} 
                  alt={`${index + 1}`}
                  className={css.bannerImagePC}
                />
              </div>

              {/* 原始代码（已注释保留） */}
              {/* <div 
                className={css.bannerSlide}
                onClick={() => handleBannerClick(banner)}
              >
                <Image 
                  src={banner.bannerUrl} 
                  alt={`${index + 1}`}
                  className={css.bannerImage}
                />
              </div> */}
            </SwiperSlide>
          ))}
        </Swiper>
      ) : fallbackImage ? (
        <>
          {/* 移动端：简单展示（使用原生img标签） */}
          <div className={css.fallbackMobile}>
            <img 
              src={fallbackImage} 
              alt=""
              className={css.fallbackImageMobile}
            />
          </div>
          
          {/* PC端：带背景蒙版 */}
          <div className={css.fallbackContainer}>
            {/* 背景蒙版层 */}
            <div 
              className={css.backgroundMask} 
              style={{ backgroundImage: `url(${fallbackImage})` }}
            />
            {/* 居中显示的图片 */}
            <Image src={fallbackImage} className={css.fallbackImage} />
          </div>
        </>
        // <Image src={fallbackImage} />
      ) : null}
    </div>
  );
};

export default BannerSwiper; 